import type { TypeTableColumn } from '@thefarmersfront/kitchen';

import { formatNumber } from '~/utils/common';

type TypeStockQuantities = {
  totalQuantity: number;
  availableQuantity: number;
  allocationQuantity: number;
  holdingQuantity: number;
  defectiveQuantity: number;
};

const formatQuantity = (value: unknown): string => (typeof value === 'number' && value ? formatNumber(value) : '-');

const RIGHT_ALIGN = { cellStyle: { textAlign: 'right' } } as const;

/** [상품별 조회]·[유통기한별 조회] 가 함께 쓰는 재고 수량 컬럼. */
export const getStockQuantityColumns = <TData extends TypeStockQuantities>(): TypeTableColumn<TData>[] => [
  {
    accessorKey: 'totalQuantity',
    header: '전체 재고',
    size: 80,
    cell: ({ getValue }) => formatQuantity(getValue()),
    meta: RIGHT_ALIGN,
  },
  {
    accessorKey: 'availableQuantity',
    header: '가용 재고',
    meta: {
      cellStyle: { textAlign: 'right' },
      headerTooltip: { description: '고객에게 판매 가능한 재고입니다.', maxWidth: '182px' },
    },
    size: 96,
    cell: ({ getValue }) => formatQuantity(getValue()),
  },
  {
    accessorKey: 'allocationQuantity',
    header: '작업중 재고',
    meta: {
      cellStyle: { textAlign: 'right' },
      headerTooltip: { description: '주문이 들어와 생산 중이거나, 이동 중인 재고입니다.', maxWidth: '266px' },
    },
    size: 112,
    cell: ({ getValue }) => formatQuantity(getValue()),
  },
  {
    accessorKey: 'holdingQuantity',
    header: '보류 재고',
    meta: {
      cellStyle: { textAlign: 'right' },
      headerTooltip: {
        description:
          '가용 혹은 불용 재고 여부를 판단하기 위해 대기중인 재고,\n혹은 반출/폐기로 인해 센터에서 사라질 예정인 재고입니다.',
        maxWidth: '299px',
      },
    },
    size: 96,
    cell: ({ getValue }) => formatQuantity(getValue()),
  },
  {
    accessorKey: 'defectiveQuantity',
    header: '불용 재고',
    meta: {
      cellStyle: { textAlign: 'right' },
      headerTooltip: { description: '판매 불가한 재고입니다.', maxWidth: '137px' },
    },
    size: 96,
    cell: ({ getValue }) => formatQuantity(getValue()),
  },
];
